import { PriceModes } from "../PriceModeCard/types";
import { RowType } from "./types";
import * as yup from "yup";
import { DeviceEventEmitter } from "react-native";
import { useEffect, useState } from "react";
import { addComma, percent } from "@utils/product/productFormatters";
import {
  addPercentage,
  calculateItemPrices,
  calculateParcelValues,
  formatNumberWithPrecision,
} from "@utils/product/productFormatters";
import { isMeleeItem } from "@utils/product/productValidators";
export const mapDataToLabels = (Data: any, formData: any) => {
  return Object.keys(Data || []).reduce((acc, key) => {
    const name = formData.find((item: any) => item.name === key)?.name ?? "";
    if (
      name &&
      name !== "comments" &&
      name !== "hold_hours" &&
      name !== "pricePerOffer" &&
      name !== "totalOfferPrice" &&
      name !== "totalOfferDiscount" &&
      name !== "radioSelect" &&
      name !== "requestedTotalCarat" &&
      name !== "requestedQuantity" &&
      name !== "parcelPriceSection"
    ) {
      //@ts-ignore
      acc[name] = Data[key];
    }
    return acc;
  }, {});
};

export const mapDataToIframeLabels = (data: any, formData: any) => {
  return Object.keys(data || {}).reduce(
    (acc, key) => {
      const name = formData.find((item: any) => item.name === key)?.name ?? "";

      if (["full_name", "phone", "email"].includes(name)) {
        //@ts-ignore
        acc.iframe_user_details[name] = data[key];
      } else if (name && name !== "comments") {
        //@ts-ignore
        acc.store_customer_attributes[name] = data[key];
      }

      return acc;
    },
    {
      iframe_user_details: {},
      store_customer_attributes: {},
    }
  );
};

export const getInputNames = (data: any) => {
  return data.map((item: any) => item.name);
};

export const resetFormForInputs = (
  formInputs: any,
  resetForm: any,
  setValue: any
) => {
  formInputs.forEach((input: any) => {
    if (input.resetForm) {
      resetForm(input.name);
      setValue(input.name, "");
    }
  });
};

export const useDebounce = (value: string, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      if (handler) {
        clearTimeout(handler);
      }
    };
  }, [value, delay]);

  return debouncedValue;
};

export const filterAndSortFormData = (formData: any, priceMode: PriceModes) => {
  if (formData && Object.keys(formData)?.length) {
    const jsonArray = Object.keys(formData)
      ?.map((key: string) => {
        return {
          ...formData[key],
          name: key,
        };
      })
      ?.filter((item) => item.price_modes?.includes(priceMode))
      ?.sort((a: any, b: any) => (a.order || 0) - (b.order || 0));
    return jsonArray;
  } else {
    return [];
  }
};

export const formatDiscountValue = (value: string, fromFilters?: boolean) => {
  let formattedValue = value.replace(/[^0-9.-]/g, "");

  if (formattedValue.includes("-")) {
    formattedValue = formattedValue.replace(/-/g, "");
    formattedValue = "-" + formattedValue;
  }

  let parts = formattedValue.split(".");

  if (fromFilters) {
    if (formattedValue.startsWith("-")) {
      parts[0] = parts[0].slice(0, 3);
    } else {
      parts[0] = parts[0].slice(0, 3);
    }
  }

  if (parts.length > 2) {
    formattedValue = parts[0] + "." + parts.slice(1).join("");
    parts = formattedValue.split(".");
  }

  if (parts.length === 2) {
    parts[1] = parts[1].slice(0, 2);
  }

  formattedValue = parts.join(".");

  if (formattedValue.startsWith(".")) {
    formattedValue = "0" + formattedValue;
  } else if (formattedValue.startsWith("-.")) {
    formattedValue = "-0" + formattedValue.slice(1);
  }

  return formattedValue;
};

export const toFixed = (
  key: any,
  getValues: any,
  setValue: any,
  userInfo: any,
  item?: any
) => {
  let val = getValues(key);
  let parsedVal = parseFloat((val + "").replaceAll(",", ""));

  if (!isNaN(parsedVal)) {
    if (key === "pricePerOffer") {
      setValue(
        key,
        addComma(formatNumberWithPrecision(parsedVal, { precision: 0 }) ?? "0")
      );
    } else {
      if (userInfo?.roundUpPrices() && !isMeleeItem(item))
        setValue(
          key,
          addComma(
            formatNumberWithPrecision(parsedVal, { precision: 0 }) ?? "0"
          )
        );
      else
        setValue(
          key,
          addComma(
            formatNumberWithPrecision(parsedVal, { precision: 2 }) ?? "0.00"
          )
        );
    }
  } else {
    setValue(key, "");
  }
};
export const onBlurChange = (
  key: string,
  onBlur: () => void,
  value: string,
  getValues: (key: string) => any,
  setValue: (key: string, value: any) => void,
  userInfo: { roundUpPrices?: () => boolean },
  onDataChange: (itemId: any, values: any) => void,
  onRequestForm: (key: string, value: any) => void,
  values: Record<string, any>,
  itemId: any,
  hasSingleItems?: boolean,
  showModal?: (modalType: string, callback: () => void) => void,
  resetSingleFormValues?: () => void,
  setRequestFormValue?: any,
  item?: any
) => {
  const handleTotalPriceOffer = () => {
    resetSingleFormValues?.();
    DeviceEventEmitter.emit("RESET_BULK_ITEM_ARRAY");

    onRequestForm(
      "totalOfferPrice",
      Number(values?.offerTotalPrice.replace(/,/g, ""))
    );
    onRequestForm("requestForm", values);
  };
  const modalFunc = () => {
    handleTotalPriceOffer();
    setRequestFormValue("offerTotalDiscount", "");
  };
  const discountModalFunc = () => {
    resetSingleFormValues?.();
    DeviceEventEmitter.emit("RESET_BULK_ITEM_ARRAY");
    setValue("offerTotalDiscount", addPercentage(value));
    setRequestFormValue("offerTotalDiscount", addPercentage(value));
  };
  const updateValueWithFixedFormat = (fieldKey: string) => {
    if (userInfo?.roundUpPrices?.()) {
      toFixed(fieldKey, getValues, setValue, userInfo, item);
    }
    if (!value) {
      if (key === "totalOfferPrice") {
        setValue(fieldKey, "0.00");
      }
    }
    if (value.endsWith(".")) {
      setValue(fieldKey, value + "00");
    }
  };

  const handleTotalOfferPrice = () => {
    updateValueWithFixedFormat(key);

    if (key === "totalOfferPrice") {
      onDataChange(itemId, values);
    } else if (hasSingleItems && showModal && value) {
      showModal("reset-single-form", () => modalFunc());
    } else {
      onRequestForm(
        "totalOfferPrice",
        Number(values?.offerTotalPrice.replace(/,/g, ""))
      );
      onRequestForm("requestForm", values);
    }

    addComma(value.replaceAll(",", ""));
  };

  if (key === "pricePerOffer") {
    toFixed("pricePerOffer", getValues, setValue, userInfo, item);
    if (!value) {
      setValue("pricePerOffer", "0");
    }
    onDataChange(itemId, values);
    addComma(value.replaceAll(",", ""));
  } else if (key === "totalOfferPrice" || key === "offerTotalPrice") {
    handleTotalOfferPrice();
  } else if (key === "totalOfferDiscount") {
    const mValue = addPercentage(value);
    setValue("totalOfferDiscount", mValue);
    onDataChange(itemId, values);
  } else if (key === "offerTotalDiscount") {
    if (value === "-") {
      setValue("offerTotalDiscount", "");
    } else if (value && value !== "-") {
      if (hasSingleItems && showModal && value) {
        showModal("offer-total-discount", () => discountModalFunc());
      } else {
        setValue("offerTotalDiscount", addPercentage(value));
        setRequestFormValue("offerTotalDiscount", addPercentage(value));
      }
    } else if (!value) {
      setValue("offerTotalDiscount", percent("0"));
      setRequestFormValue("offerTotalDiscount", percent("0"));
    }
  }
  onBlur();
};

export const onParcelBlurChange = (
  key: string,
  onBlur: () => void,
  value: string,
  setValue: (key: string, value: any) => void,
  onDataChange: (itemId: any, values: any) => void,
  values: Record<string, any>,
  itemId: any,
  enableFourDecimalCarat: boolean
) => {
  const updateValueWithFixedFormat = (fieldKey: string) => {
    if (value.endsWith(".")) {
      setValue(fieldKey, value + "00");
    }
  };

  const handleTotalCarat = () => {
    updateValueWithFixedFormat(key);
    if (value && !value.endsWith(" ct")) {
      const _carat = formatNumberWithPrecision(value, {
        precision: enableFourDecimalCarat ? 4 : 3,
      });
      setValue(key, _carat + " ct");
    }
    onDataChange(itemId, values);
  };

  if (key === "requestedQuantity") {
    if (!value) {
      setValue("requestedQuantity", "");
    }
    onDataChange(itemId, values);
    addComma(value.replaceAll(",", ""));
  } else if (key === "requestedTotalCarat") {
    handleTotalCarat();
  }
  onBlur();
};

export const onParcelChangeText = (
  key: string,
  val: string,
  onChange: (value: string) => void,
  onDataChange: (id: any, values: any) => void,
  values: Record<string, any>,
  itemDetail: { id: any },
  setValue: (key: string, value: any) => void,
  setError: (key: string, value: any) => void,
  enableFourDecimalCarat: boolean
) => {
  const lastChar = val.slice(-1);
  const isDecimalAttempt = lastChar === ",";

  const formatDecimalValue = (value: string, mIsDecimalAttempt: boolean) => {
    let formattedValue = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    const firstDecimalIndex = formattedValue.indexOf(".");

    if (firstDecimalIndex !== -1) {
      formattedValue =
        formattedValue.slice(0, firstDecimalIndex + 1) +
        formattedValue.slice(firstDecimalIndex + 1).replace(/\./g, "");
      formattedValue = formattedValue.slice(
        0,
        firstDecimalIndex + (enableFourDecimalCarat ? 5 : 4)
      );
    }

    if (formattedValue.startsWith(".")) {
      formattedValue = "0" + formattedValue;
    }

    if (mIsDecimalAttempt && !formattedValue.includes(".")) {
      formattedValue += ".";
    }
    return formattedValue;
  };

  if (key === "requestedQuantity") {
    const formattedValue = val.replace(/,/g, "").replace(/[^0-9]/g, "");
    const numericValue = Number(formattedValue);
    if (numericValue > 9999) {
      setError("requestedQuantity", {
        type: "manual",
        message: "Maximum quantity is 9999",
      });
      return;
    }
    onChange(formattedValue);

    reCalculateParcelValues(
      "quantity",
      formattedValue,
      itemDetail,
      setValue,
      values,
      onDataChange,
      enableFourDecimalCarat
    );
  } else if (key === "requestedTotalCarat") {
    const formattedValue = formatDecimalValue(val, isDecimalAttempt);
    const maxValue = Number((itemDetail as any)?.size as string) * 9999;

    if (Number(formattedValue) > maxValue) {
      setError("requestedTotalCarat", {
        type: "manual",
        message: `Maximum carat is ${maxValue}`,
      });
      return;
    }
    reCalculateParcelValues(
      "totalCarat",
      formattedValue,
      itemDetail,
      setValue,
      values,
      onDataChange,
      enableFourDecimalCarat
    );
    onChange(formattedValue);
  }
};

export const onChangeText = (
  key: string,
  val: string,
  onChange: (value: string) => void,
  onDataChange: (id: any, values: any) => void,
  onRequestForm: (key: string, value: any) => void,
  values: Record<string, any>,
  itemDetail: { id: any },
  userInfo: any,
  setValue: (key: string, value: any) => void,
  setError: (key: string, value: any) => void,
  disableDiscountFiled: boolean
) => {
  const formatDecimalValue = (value: string, isDecimalAttempt: boolean) => {
    let formattedValue = value.replace(/,/g, "").replace(/[^0-9.]/g, "");
    const firstDecimalIndex = formattedValue.indexOf(".");

    if (firstDecimalIndex !== -1) {
      formattedValue =
        formattedValue.slice(0, firstDecimalIndex + 1) +
        formattedValue.slice(firstDecimalIndex + 1).replace(/\./g, "");
      formattedValue = formattedValue.slice(0, firstDecimalIndex + 3);
    }

    if (formattedValue.startsWith(".")) {
      formattedValue = "0" + formattedValue;
    }

    if (isDecimalAttempt && !formattedValue.includes(".")) {
      formattedValue += ".";
    }

    return formattedValue;
  };

  const lastChar = val.slice(-1);
  const isDecimalAttempt = lastChar === ",";

  if (key === "totalOfferPrice" || key === "offerTotalPrice") {
    const formattedValue = formatDecimalValue(val, isDecimalAttempt);
    onChange(formattedValue);

    if (key === "totalOfferPrice") {
      if (!val) {
        setError("totalOfferPrice", {
          type: "manual",
          message: "Please enter a value",
        });
      }
      reCalculatePrices(
        "tp",
        formattedValue,
        itemDetail,
        userInfo,
        setValue,
        disableDiscountFiled
      );
      onDataChange(itemDetail?.id, values);
    } else {
      onRequestForm("requestForm", values);
      setValue("offerTotalPrice", addComma(formattedValue));
    }
  } else if (key === "pricePerOffer") {
    const formattedValue = val.replace(/,/g, "").replace(/[^0-9]/g, "");
    if (!val) {
      setError("pricePerOffer", {
        type: "required",
        message: "Please enter a value",
      });
    }
    reCalculatePrices(
      "ppc",
      formattedValue,
      itemDetail,
      userInfo,
      setValue,
      disableDiscountFiled
    );
    onDataChange(itemDetail?.id, values);
    onChange(formattedValue);
  } else if (key === "totalOfferDiscount") {
    let value = formatDiscountValue(val);
    reCalculatePrices("discount", value, itemDetail, userInfo, setValue);
    onDataChange(itemDetail?.id, values);
    onChange(value);
  } else if (key === "offerTotalDiscount") {
    let value = formatDiscountValue(val);
    if (!values.offerTotalDiscount && values.offerTotalDiscount !== "-") {
      onChange("-");
    }
    onChange(value);
  } else {
    onChange(val);
  }
};

export const reCalculateParcelValues = (
  fieldKey: string,
  value: string,
  itemDetail: any,
  setValue: any,
  values: Record<string, any>,
  onDataChange: (id: any, values: any) => void,
  enableFourDecimalCarat: boolean
) => {
  value = value.replaceAll(",", "");
  const calculatedPrice = calculateParcelValues(
    itemDetail,
    fieldKey,
    value,
    enableFourDecimalCarat
  );

  let quantity = "";
  let totalCarat = "";

  switch (fieldKey) {
    case "quantity":
      quantity = calculatedPrice?.quantity || "";
      totalCarat = calculatedPrice?.totalCarat || "";
      break;
    case "totalCarat":
      totalCarat = calculatedPrice?.totalCarat || "";
      quantity = calculatedPrice?.quantity || "";
      break;
  }

  setValue("requestedQuantity", quantity);
  setValue("requestedTotalCarat", totalCarat === "" ? "" : totalCarat + " ct");
  values.requestedQuantity = quantity;
  values.requestedTotalCarat = totalCarat === "" ? "" : totalCarat + " ct";
  onDataChange(itemDetail?.id, values);
};

export const reCalculatePrices = (
  fieldKey: string,
  value: string,
  itemDetail: any,
  userInfo: any,
  setValue: any,
  disableDiscountFiled?: boolean
) => {
  value = value.replaceAll(",", "");
  const calculatedPrice = calculateItemPrices(itemDetail, fieldKey, value);

  let tp = "";
  let ppc = "";
  let discount = "";

  switch (fieldKey) {
    case "ppc":
      tp = calculatedPrice.totalPrice
        ? userInfo?.roundUpPrices() && !isMeleeItem(itemDetail)
          ? formatNumberWithPrecision(calculatedPrice.totalPrice, {
              precision: 0,
            })
          : formatNumberWithPrecision(calculatedPrice.totalPrice, {
              precision: 2,
            })
        : "";
      ppc = value || "";
      discount = disableDiscountFiled
        ? "-"
        : calculatedPrice.discount
        ? percent(
            formatNumberWithPrecision(calculatedPrice.discount, {
              precision: 2,
            })
          )
        : "";
      break;
    case "tp":
      tp = value || "";
      ppc = calculatedPrice.ppc
        ? formatNumberWithPrecision(calculatedPrice.ppc, { precision: 0 })
        : "";
      discount = disableDiscountFiled
        ? "-"
        : calculatedPrice.discount
        ? percent(
            formatNumberWithPrecision(calculatedPrice.discount, {
              precision: 2,
            })
          )
        : "";
      break;
    case "discount":
      discount = value || "";
      tp = calculatedPrice.totalPrice
        ? userInfo?.roundUpPrices() && !isMeleeItem(itemDetail)
          ? formatNumberWithPrecision(calculatedPrice.totalPrice, {
              precision: 0,
            })
          : formatNumberWithPrecision(calculatedPrice.totalPrice, {
              precision: 2,
            })
        : "";
      ppc = calculatedPrice.ppc
        ? formatNumberWithPrecision(calculatedPrice.ppc, { precision: 0 })
        : "";
      break;
  }
  setValue("totalOfferPrice", addComma(tp.replaceAll(",", "")));
  setValue("pricePerOffer", addComma(ppc.replaceAll(",", "")));
  setValue("totalOfferDiscount", discount);
  // setPpcValidation(
  //   !ppc || ppc === "0"
  //     ? `Please enter a price greater than ${userInfo.user.currency_symbol}0`
  //     : ""
  // );
  // setTpValidation(
  //   !tp || Number(tp) === 0
  //     ? `Please enter a price greater than ${userInfo.user.currency_symbol}0`
  //     : ""
  // );
};

export const generateYupSchema = (formStructure: RowType[], t: any) => {
  const schemaObject: { [key: string]: yup.Schema<any> } = {};

  formStructure.forEach((field) => {
    let fieldSchema: yup.Schema<any>;

    switch (field.type) {
      case "dropdown":
        fieldSchema = yup.string();
        break;
      case "date":
        fieldSchema = yup
          .string()
          .test("is-date-string", "Invalid date format", (value) => {
            if (!field.validations?.required && !value) return true;
            if (!value) return false;

            // Check if it's a string
            if (typeof value !== "string") return false;

            const dateRegex = /^(\d{1,2}) ([A-Z][a-z]{2}), (\d{4})$/;
            const match = dateRegex.exec(value);
            if (!match) return false;

            const [, day, month, year] = match;
            const months = [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ];
            const monthIndex = months.indexOf(month);

            if (monthIndex === -1) return false;

            const dayNumber = Number(day);
            const yearNumber = Number(year);

            const date = new Date(yearNumber, monthIndex, dayNumber);
            return (
              date.getFullYear() === yearNumber &&
              date.getMonth() === monthIndex &&
              date.getDate() === dayNumber
            );
          });
        break;
      case "countryCode":
        fieldSchema = yup
          .string()
          .required(t("validation.countryCodeRequired"));
        break;
      default:
        fieldSchema = yup.string();
    }

    if (field.validations) {
      const { required, min, max, regex, errorMessage } = field.validations;

      if (required) {
        fieldSchema = fieldSchema.required(t(errorMessage));
      }

      if (min !== undefined) {
        //@ts-ignore
        fieldSchema = fieldSchema.min(min, t(errorMessage));
      }

      if (max !== undefined) {
        //@ts-ignore
        fieldSchema = fieldSchema.max(max, t(errorMessage));
      }

      if (regex) {
        //@ts-ignore
        fieldSchema = fieldSchema.matches(
          new RegExp(regex.pattern, regex.flags),
          t(errorMessage)
        );
      }
    }

    schemaObject[field.name] = fieldSchema;
  });

  return yup.object().shape(schemaObject);
};

export const generateHoldOptions = (maxHoldHours: string[], t: any) => {
  return maxHoldHours.map((hour) => {
    const hourValue = parseInt(hour, 10);
    const label =
      hourValue <= 72
        ? `${hourValue} ${t("bmh.hold.hour.type.hour.text")}`
        : `${Math.floor(hourValue / 24)} ${t("bmh.hold.hour.type.days.text")}`;
    const value =
      hourValue <= 72
        ? `${hourValue} ${t("bmh.hold.hour.type.hour.text")}`
        : `${Math.floor(hourValue / 24)} ${t("bmh.hold.hour.type.days.text")}`;

    return { label, value };
  });
};

export const hasFancyItem = (itemList?: any[], itemDetail?: any) => {
  if (itemList?.length && itemList?.length > 1) {
    return itemList?.some((item) => item?.item?.is_fancy === true) || false;
  } else if (itemDetail) {
    if (itemDetail?.is_fancy) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const hasNullDiscountItem = (itemList?: any[], itemDetail?: any) => {
  if (itemList?.length && itemList?.length > 0) {
    return (
      itemList?.some(
        (item) =>
          item?.item?.discount_percent === null ||
          item?.item?.discount_percent === undefined
      ) || false
    );
  } else if (itemDetail) {
    if (itemDetail?.discount_percent) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};
